export default __webpack_public_path__ + "static/3-84cd12c915c87a238dc53dc7a123860c.jpg";